// Abbreviated category names (unique identifiers)
export const STAT_CATEGORIES_ABBR = {
  // Offensive Stats
  totalYards: 'YDS',
  totalPlays: 'PLAYS',
  totalYardsPerPlay: 'YDS_PL',
  totalPassingYards: 'PASS_YDS',
  totalPassCompletions: 'COMP',
  totalPassAttempts: 'ATT',
  totalPassingPercentage: 'COMP_PCT',
  totalPassingYardsPerAttempt: 'YDS_ATT',
  totalRushingYards: 'RUSH_YDS',
  totalRushingAttempts: 'RUSH_ATT',
  totalRushingYardsPerAttempt: 'YDS_RUSH',
  totalPointsScored: 'PTS_FOR',
  totalInterceptionsThrown: 'INT_THR',
  totalFumblesLost: 'FUM_LOST',
  totalTimeOfPossession: 'TOP',
  totalPenalties: 'PEN',
  totalPenaltyYards: 'PEN_YDS',
  totalSackedTimes: 'SACKED',
  totalSackedYardsLost: 'SACK_YDS',
  totalDrives: 'DRIVES',

  // Third Down Stats
  totalThirdDownAttempts: '3RD_ATT',
  totalThirdDownConverted: '3RD_CONV',
  totalThirdDownEfficiency: '3RD_PCT',

  // Red Zone Stats
  totalRedZoneScored: 'RZ_SCORE',
  totalRedZoneAttempts: 'RZ_ATT',
  totalRedZoneEfficiency: 'RZ_PCT',

  // First Down Stats
  totalFirstDowns: '1ST_DN',
  totalFirstDownsFromPassing: '1ST_PASS',
  totalFirstDownsFromPenalties: '1ST_PEN',
  totalFirstDownsFromRushing: '1ST_RUSH',

  // Fourth Down Stats
  totalFourthDownScored: '4TH_SCORE',
  totalFourthDownAttempts: '4TH_ATT',
  totalFourthDownEfficiency: '4TH_PCT',

  // Defensive Stats
  totalYardsAllowed: 'YDS_ALLOW',
  totalPassingYardsAllowed: 'PASS_ALLOW',
  totalRushingYardsAllowed: 'RUSH_ALLOW',
  totalPointsAllowed: 'PTS_ALLOW',
  totalSacks: 'SACKS',
  totalDefensiveInterceptions: 'INT',
  totalFumblesRecovered: 'FUM_REC',
  totalSafeties: 'SAFETY',
  totalDefensiveOrSpecialTeamsTds: 'DEF_TD',
  totalForcedFumbles: 'FUM_FORCE',

  // Defensive Pass Defense Stats
  totalPassIncompletions: 'INCOMP',
  totalPassAttemptsAgainst: 'ATT_A',
  totalPassIncompletePercentage: 'INCOMP_PCT',

  // Defensive Third Down Stats
  totalThirdDownAttemptsAgainst: '3RD_ATT_A',
  totalThirdDownStops: '3RD_STOP',
  totalThirdDownStopEfficiency: '3RD_PCT_STOP',

  // Defensive Fourth Down Stats
  totalFourthDownStops: '4TH_STOP',
  totalFourthDownAttemptsAgainst: '4TH_ATT_A',
  totalFourthDownStopEfficiency: '4TH_PCT_STOP',

  // Defensive Red Zone Stats
  totalRedZoneStops: 'RZ_STOP',
  totalRedZoneAttemptsAgainst: 'RZ_ATT_A',
  totalRedZoneStopEfficiency: 'RZ_PCT_STOP',

  // Scoring Stats
  totalScoringPassingTDFor: 'TD_PASS_F',
  totalScoringRushingTDFor: 'TD_RUSH_F',
  totalScoringFGFor: 'FG_F',
  totalScoringEPFor: 'EP_F',
  totalScoring2PtFor: '2PT_F',
  totalScoringTotalTDFor: 'TD_TOT_F',

  totalScoringPassingTDAgainst: 'TD_PASS_A',
  totalScoringRushingTDAgainst: 'TD_RUSH_A',
  totalScoringFGAgainst: 'FG_A',
  totalScoringEPAgainst: 'EP_A',
  totalScoring2PtAgainst: '2PT_A',
  totalScoringTotalTDAgainst: 'TD_TOT_A',
} as const;
